import Api from "./Api";
import axios from "axios";
import Session from "@/classes/Session";
import store from "@/store";
import { apiUrl } from "@/config/config";

class ContactsApi extends Api {
  constructor(version = "public/v2") {
    super(version);
    let jwt = Session.getJwtCookie();

    this.http = axios.create({
      baseURL: apiUrl + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      Session.logout();
      jwt = "";
    } else {
      this.set_jwt(jwt);
    }
    this.page_length = 25;
  }

  import(formData, locale = "de") {
    formData.locale = locale;

    return new Promise((resolve, reject) => {
      this.http
        .post("contacts/import", formData)
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  //this request gets all contacts and also performs filtering and searching on the contact table
  async getAllContacts(params = {}) {
    if (params) {
      params = {
        contact_filters: params["contact_filters"]
          ? params["contact_filters"]
          : {},
        search: params["search"] ? params["search"] : "",
        per_page: params["per_page"] ? params["per_page"] : 25,
        page: params["page"] ? params["page"] : 1,
        sort_by: params["sort_by"] ? params["sort_by"] : "id",
        sort_order: params["sort_order"] ? params["sort_order"] : "ASC"
      };
    } else {
      params = {};
    }

    let response = await this.http.get("contacts", {
      params: params
    });

    return response;
  }

  async getContactsCompany(params) {
    let response = await this.http.get("companies" + "/" + params);
    return response.data.resource;
  }

  async getContact(params) {
    let response = await this.http.get("contacts/" + params);
    return response.data.resource;
  }

  async delete(id) {
    let ids = [];
    if (Array.isArray(id)) {
      ids = id;
    } else {
      ids = [id];
    }
    let report = {};
    let numSucceeded = 0;
    let numFailed = 0;
    for (const id of ids) {
      let results = await this.http.delete("contacts/" + id);
      if (results.status == 204) {
        numSucceeded += 1;
      } else {
        numFailed += 1;
      }
      report[id] = {
        status: results.status,
        statusText: results.statusText
      };
    }
    report["summary"] = {
      num_succeeded: numSucceeded,
      num_failed: numFailed
    };
    return report;
  }

  async exportContacts(params = {}) {
    let response = await this.http.put("contacts/export_contacts", params);

    return response;
  }

  async updateContact(id, params) {
    let response = await this.http.put(`contacts/${id}`, params);

    if (response.status == 201) {
      store.commit("SET_NOTIFICATION", {
        title: "ui.contacts.actions.success",
        type: "success"
      });
    } else {
      store.commit("SET_NOTIFICATION", {
        title: "ui.contacts.actions.error",
        type: "error"
      });
    }

    return response.data.resource;
  }
  
  async updateContactsCompany(params) {
    const response = await this.http.put("contacts/company_update", {
      company_id: params["companyId"],
      contact_ids: params["contactIds"],
    });
    if (response.status == 204) {
      store.commit("SET_NOTIFICATION", {
        title: "ui.contacts.actions.success",
        type: "success",
      });
    } else {
      store.commit("SET_NOTIFICATION", {
        title: "ui.contacts.actions.error",
        type: "error"
      });
    }

    return response.data.resource;
  }

  async sendBusinessKits(params = {}) {
    let response = await this.http.post("contacts/send_business_kits", {
      business_kit_id: params["businessKitId"],
      project_name: params["projectName"],
      segment_id: params["segmentId"],
      organization_id: params["organizationId"],
      contact_ids: params["contactIds"]
    });

    return response;
  }

  async addToProject(params = {}) {
    let response = await this.http.post("contacts/add_to_project", {
      project_id: params["projectId"],
      segment_id: params["segmentId"],
      organization_id: params["organizationId"],
      contact_ids: params["contactIds"]
    });

    return response;
  }

  send_xls(contact_id, email, locale) {
    return new Promise((resolve, reject) => {
      this.http
        .put("/contacts/" + contact_id + "/send_lead_export_via_email", {
          params: { email: email, locale: locale }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }

  search(params, searchQuery) {
    if (!params.per_page) {
      params.per_page = this.page_length;
    }

    params.query = searchQuery;
    return new Promise((resolve, reject) => {
      this.http
        .get("contacts/search", { params })
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          this.handleError(e);
          reject(e);
        });
    });
  }
}

export default ContactsApi;



// WEBPACK FOOTER //
// ./src/api/Contacts.js